module.exports = {
	"name": "@elastic/kibana-ui-framework",
	"version": "0.0.13",
	"description": "Kibana UI Framework",
	"main": "index.js",
	"scripts": {
		"start": "./node_modules/.bin/webpack-dev-server --hot --inline --content-base public/",
		"build": "./node_modules/.bin/webpack",
		"deploy": "npm run build; gh-pages -d public -r https://github.com/elastic/kibana-ui-framework",
		"dist": "node-sass ./src/framework/framework.scss ./dist/framework.css",
		"preversion": "npm run dist",
		"postversion": "npm run deploy"
	},
	"dependencies": {},
	"devDependencies": {
		"@elastic/eslint-config-kibana": "0.1.0",
		"autoprefixer": "6.5.3",
		"babel-core": "6.10.4",
		"babel-eslint": "4.1.8",
		"babel-loader": "6.2.4",
		"babel-polyfill": "6.9.1",
		"babel-preset-es2015": "6.9.0",
		"babel-preset-react": "6.11.1",
		"classnames": "2.2.5",
		"css-loader": "0.23.1",
		"del": "1.2.1",
		"eslint": "1.10.3",
		"eslint-plugin-jasmine": "1.6.0",
		"eslint-plugin-mocha": "1.1.0",
		"eslint-plugin-react": "3.16.1",
		"expose-loader": "0.7.1",
		"gh-pages": "0.11.0",
		"highlight.js": "9.0.0",
		"history": "2.1.1",
		"html-loader": "0.4.3",
		"jquery": "3.1.0",
		"json-loader": "0.5.4",
		"keymirror": "0.1.1",
		"node-sass": "3.8.0",
		"postcss-loader": "1.2.0",
		"raw-loader": "0.5.1",
		"react": "15.2.0",
		"react-addons-test-utils": "15.2.0",
		"react-dom": "15.2.0",
		"react-redux": "4.4.5",
		"react-router": "2.0.0",
		"react-router-redux": "4.0.4",
		"redux": "3.0.0",
		"redux-thunk": "0.1.0",
		"sass-loader": "4.0.0",
		"style-loader": "0.13.1",
		"webpack": "1.13.1",
		"webpack-dev-server": "1.14.1"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./package.json
 ** module id = 754
 ** module chunks = 0
 **/